import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HookHandlerClass;
function HookHandler() {
  if (HookHandlerClass === VOID) {
    class $ {
      constructor(hook, handler) {
        this.l5s_1 = hook;
        this.m5s_1 = handler;
      }
      w5g(client) {
        this.l5s_1.m5m(client, this.m5s_1);
      }
    }
    initMetadataForClass($, 'HookHandler');
    HookHandlerClass = $;
  }
  return HookHandlerClass;
}
//region block: exports
export {
  HookHandler as HookHandler356pvj77mag23,
};
//endregion

//# sourceMappingURL=ClientHook.mjs.map
